import styled from 'styled-components';
import { Link } from 'react-router-dom'; 

// Reports Page Container
export const ReportsPageContainer = styled.div.attrs(() => ({
  className: 'bg-gray-100 font-serif px-4', // Added padding for smaller screens
}))``;

// Reports Section
export const ReportsSection = styled.div.attrs(() => ({
  className: 'max-w-5xl mx-auto py-14',
}))``;

// Report Card
export const ReportCard = styled.div.attrs(() => ({
  className: 'flex flex-col md:flex-row items-start mb-14 transition-all duration-300 ease-in-out',
}))``;

// Report Image
export const ReportImage = styled.img.attrs(() => ({
  className: 'w-full md:w-1/2 rounded-lg mb-6 md:mb-0',
}))``;

// Report Text Container
export const ReportText = styled.div.attrs(() => ({
  className: 'md:ml-8 relative text-center md:text-left', // Center text on small screens
}))``;

// Report Date
export const ReportDate = styled.p.attrs(() => ({
  className: 'text-gray-500 text-sm md:text-base mb-3', // Smaller font size for mobile
}))``;

// Report Title
export const ReportTitle = styled.h2.attrs(() => ({
  className: 'text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-6 cursor-pointer', // Scalable font sizes
}))``;

// Report Description (Hidden by default)
export const ReportDescription = styled.div.attrs(() => ({
  className: 'overflow-hidden transition-all duration-300 ease-in-out max-h-0 opacity-0 text-sm md:text-base', // Responsive font size
}))``;

// Read More Link
export const ReadMoreLink = styled(Link).attrs(() => ({
  className: 'text-blue-600 underline hover:text-blue-800 text-sm md:text-base', // Scalable font sizes
}))``;
